module.exports = __webpack_public_path__ + "img/Step3.f9a108af.png";